var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[(_vm.orders)?[_c('OrdersList',{attrs:{"orders":_vm.orders},on:{"order-click":_vm.viewOrder}})]:_c('div',{staticClass:"text-center"},[_vm._v("Loading...")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }